import React from 'react';
import alainPhoto from "../assets/alain-portrait.jpeg";
import HeroImg from '../assets/bg-header.jpg';

export const About = () => {
  return (
    <main className="font-sans antialiased bg-white">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center bg-black overflow-hidden">
        <img src={HeroImg} alt="Coach Alain" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/70" />
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6 animate-fade-in">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">Meet the <span className="text-primary italic">Coach</span></h1>
          <div className="w-16 h-1.5 bg-primary mx-auto rounded-full" />
        </div>
      </section>

      <section id="coach" className="py-24 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-extrabold text-navy mb-8">Elevating Your Technique</h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Hello, I'm <span className="font-bold text-navy">Alain</span>. Thank you for visiting my website. My teaching style focuses on deep technical mastery. Good technique will make playing tennis easier, more efficient, and far more enjoyable.
              </p>
              <p>
                I attempt to maximize your natural style of play while providing the overall balance your game needs to compete at any level. Every lesson is designed with your specific needs in mind, emphasizing foundations, body mechanics, and game strategy.
              </p>
              <p>
                I have been a certified instructor with the <a href="https://ptrtennis.org/" className="text-primary font-bold hover:underline">Professional Tennis Registry (PTR)</a> since 2000 and have been teaching the game since 1980.
              </p>
              <p>
                Check out my <a href="https://www.youtube.com/playlist?list=PLxFP6IGkuwecO6iS23mdYzxpbUvPUxbmj" className="text-primary font-bold hover:underline">YouTube channel</a> for bite-sized lessons and tennis advice.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-primary/10 rounded-3xl -rotate-3" />
            <img 
              src={alainPhoto} 
              alt="Coach Alain" 
              className="relative rounded-3xl shadow-2xl w-full h-[600px] object-cover" 
            />
          </div>
        </div>
      </section>

      <footer className="py-12 bg-navy text-white text-center">
        <p className="opacity-60 text-sm">© 2025 Alain Brouillaud | Spin Doctor Tennis</p>
      </footer>
    </main>
  );
};
